"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useStorage", {
  enumerable: true,
  get: function get() {
    return _useStorage.useStorage;
  }
});
var _useStorage = require("./useStorage");